module.exports = __webpack_public_path__ + "static/img/service-7.93fa6d52.jpg";